import React from "react";

export type LinkProps = {
  cx?: string;
  to: string;
  routerLink: any;
};

export const Link: React.FC<LinkProps> = ({
  to,
  routerLink,
  cx = "",
  children,
}) => {
  const RouterLink = routerLink;
  return (
    <RouterLink to={to} className={`Link ${cx}`}>
      {children}
    </RouterLink>
  );
};
